<template>
    <div>
        <div class="pop_open ms-2" @click="showModal">
            <div class="info_icon">
                <SvgHeaderSvg :type="'ask'" />
            </div>
        </div>
        <div v-if="flagShowModal">
            <Teleport  to="#teleports">
                <div class="modal fade" data-bs-backdrop="true" id="style" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" ref="style">
                    <div class="modal-dialog">
                        <div class="modal-body modal-content">
                            <div class="title_block mb-3">
                                <div>
                                    <h3 class="mb-0 font-active">Traceability</h3>
                                </div>
                                <span @click="hideModal"><SvgHeaderSvg :type="'close'" class="largesvg"/></span>
                            </div>
                            <div class="row">
                                <div class="col-md-12 col-12">
                                    <div class="parent_text">
                                        <p>We have integrated cutting-edge blockchain technology into our grading system to promote transparency and meet higher ethical sourcing standards. This technology enables you to track the origin of your diamond securely while tracing its journey through all processes. It also records every time the diamond changes hands from the creators at state-of-the-art laboratories to its ultimate destination: you! </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Teleport>
        </div>
    </div>
</template>

<script setup>
const flagShowModal = ref(false);
const style = ref(null);

const showModal = () => {
    flagShowModal.value = true;
    nextTick(() => {
        const modalElement = style.value;
        if (modalElement) {
            const modalInstance = new bootstrap.Modal(modalElement);
            modalInstance.show();
        }
    });
};

const hideModal = () => {
    const modalElement = style.value;
    if (modalElement) {
        const modalInstance = bootstrap.Modal.getInstance(modalElement);
        if (modalInstance) {
            modalInstance.hide();
        }
    }
    flagShowModal.value = false;
};

</script>

<style scoped>
.largesvg {
    transform: scale(1.3);
}
.pop_open{
    color: #cccccc;
    font-size: 14px;
    cursor: pointer;
}

.title_block{
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
}
p {
    font-size: 16px;
    color: #606060;
}
.title_block span {
    cursor: pointer;
}
h3{
    font-size: 22px;
}

@media(max-width: 767px){
    h3{
        font-size: 20px;
    }

   p{
        font-size: 14px;
   }
}

</style>
